import { IAppState } from '@state/types';

export const getFolders = (state: IAppState): any | undefined => state.folders.folders;

export const getFolder = (state: IAppState): any | undefined => state.folders.folder;